export const SharedType = {
  ME: false,
  TEAM: true,
};

export interface DashboardForm {
  dashboardName: string;
  shared: boolean;
  dashboardId?: number;
}
